import { withInstall } from '@hongluan-ui/utils'
import Step from '../steps/src/item.vue'

export const HlStep = withInstall(Step)
export default HlStep

